{
 "title": {
  "x": 250,
  "y": 552,
  "w": 440,
  "h": 64,
  "lane": {
   "x": 250,
   "y": 552,
   "w": 440,
   "h": 64
  }
 },
 "r1.title": {
  "x": 269,
  "y": 682,
  "w": 330,
  "h": 33,
  "lane": {
   "x": 268,
   "y": 676,
   "w": 332,
   "h": 40
  }
 },
 "r1.time": {
  "x": 588,
  "y": 684,
  "w": 72,
  "h": 28,
  "lane": {
   "x": 560,
   "y": 676,
   "w": 100,
   "h": 36
  }
 },
 "r1.sub": {
  "x": 271,
  "y": 716,
  "w": 389,
  "h": 34,
  "lane": {
   "x": 268,
   "y": 716,
   "w": 392,
   "h": 36
  }
 },
 "r1.btn": {
  "x": 670,
  "y": 700,
  "w": 136,
  "h": 44,
  "lane": {
   "x": 670,
   "y": 700,
   "w": 136,
   "h": 44
  }
 },
 "r2.title": {
  "x": 271,
  "y": 820,
  "w": 328,
  "h": 31,
  "lane": {
   "x": 268,
   "y": 814,
   "w": 332,
   "h": 40
  }
 },
 "r2.time": {
  "x": 560,
  "y": 821,
  "w": 100,
  "h": 29,
  "lane": {
   "x": 560,
   "y": 814,
   "w": 100,
   "h": 36
  }
 },
 "r2.sub": {
  "x": 271,
  "y": 854,
  "w": 389,
  "h": 30,
  "lane": {
   "x": 268,
   "y": 854,
   "w": 392,
   "h": 36
  }
 },
 "r2.btn": {
  "x": 670,
  "y": 836,
  "w": 136,
  "h": 44,
  "lane": {
   "x": 670,
   "y": 836,
   "w": 136,
   "h": 44
  }
 },
 "r3.title": {
  "x": 271,
  "y": 957,
  "w": 298,
  "h": 33,
  "lane": {
   "x": 268,
   "y": 952,
   "w": 332,
   "h": 40
  }
 },
 "r3.time": {
  "x": 560,
  "y": 958,
  "w": 138,
  "h": 30,
  "lane": {
   "x": 560,
   "y": 952,
   "w": 140,
   "h": 36
  }
 },
 "r3.sub": {
  "x": 271,
  "y": 998,
  "w": 374,
  "h": 25,
  "lane": {
   "x": 268,
   "y": 992,
   "w": 412,
   "h": 36
  }
 },
 "r4.title": {
  "x": 271,
  "y": 1094,
  "w": 242,
  "h": 32,
  "lane": {
   "x": 268,
   "y": 1090,
   "w": 332,
   "h": 40
  }
 },
 "r4.time": {
  "x": 667,
  "y": 1098,
  "w": 99,
  "h": 23,
  "lane": {
   "x": 560,
   "y": 1090,
   "w": 220,
   "h": 36
  }
 },
 "r4.sub": {
  "x": 270,
  "y": 1135,
  "w": 353,
  "h": 26,
  "lane": {
   "x": 268,
   "y": 1130,
   "w": 412,
   "h": 36
  }
 },
 "cta": {
  "x": 300,
  "y": 1240,
  "w": 340,
  "h": 52,
  "lane": {
   "x": 300,
   "y": 1240,
   "w": 340,
   "h": 52
  }
 }
}